import { forwardRef } from "react";
const SvgSortUpdownArrow = ({
  title,
  titleId,
  ...props
}, ref) => <svg width={14} height={12} viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path d="M3.66667 8.66675V0.666748M3.66667 0.666748L1 3.33341M3.66667 0.666748L6.33333 3.33341M10.3333 3.33341V11.3334M10.3333 11.3334L13 8.66675M10.3333 11.3334L7.66667 8.66675" stroke="#6C738C" strokeWidth={1.33333} strokeLinecap="round" strokeLinejoin="round" /></svg>;
const ForwardRef = forwardRef(SvgSortUpdownArrow);
export default ForwardRef;